import { SmartphotoExternalEstimationStatus } from '../../enums/smartphoto/smartphoto-external-estimation-status.enum';
export class SmartphotoEstimateInfo {
    static MAX_ATTEMPTS = 5;
    dirty;
    estimates;
    automatic;
    attempts;
    constructor(estimation, pendingGTEstimation, automatic) {
        this.estimates = estimation;
        this.dirty = pendingGTEstimation;
        this.automatic = automatic;
        this.attempts = new Set(this.estimates.map((estimate) => estimate.estimateId)).size;
    }
    getLastEstimationStatus() {
        const lastEstimation = this.estimates.sort((a, b) => b.estimatedAt - a.estimatedAt).at(0);
        if (!lastEstimation?.available && lastEstimation?.errorCode === undefined) {
            return SmartphotoExternalEstimationStatus.NOT_READY;
        }
        if (!lastEstimation.available && lastEstimation.errorCode !== undefined) {
            return SmartphotoExternalEstimationStatus.ERRORED;
        }
        return SmartphotoExternalEstimationStatus.READY;
    }
}
